
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#bae0bd","d":"M20 38.5C9.799 38.5 1.5 30.201 1.5 20S9.799 1.5 20 1.5 38.5 9.799 38.5 20 30.201 38.5 20 38.5z"}}),_c('path',{attrs:{"fill":"#5e9c76","d":"M20 2c9.925 0 18 8.075 18 18s-8.075 18-18 18S2 29.925 2 20 10.075 2 20 2m0-1C9.507 1 1 9.507 1 20s8.507 19 19 19 19-8.507 19-19S30.493 1 20 1z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"2","d":"M11 20l6 6 13-13"}})])
          )
        }
      }
    